import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useQueryClient } from '@tanstack/react-query';
import { useStore, useStoreActions } from '~/contexts';
import { isTransientError } from '~/hooks/isTransientError';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { selectors } from '~/store/state-selectors';
const makeUpdateUiPreferenceHook = ()=>()=>{
        const { api } = useStoreActions();
        const queryClient = useQueryClient();
        const businessId = useStore(selectors.user.businessId);
        const writeUiPreferenceToCache = (key, value)=>{
            const cacheKey = [
                QueryKeys.GetInfo,
                businessId
            ];
            const prev = queryClient.getQueryData(cacheKey);
            if (prev == null) return;
            queryClient.setQueryData(cacheKey, _object_spread_props(_object_spread({}, prev), {
                uiPreferences: _object_spread_props(_object_spread({}, prev.uiPreferences), {
                    [key]: value
                })
            }));
        };
        const { mutate, isLoading, error } = useMutationState({
            mutationFn: (param)=>{
                let { key, value } = param;
                if (businessId == null) return Promise.reject(new Error('missing businessId for ui preference update'));
                return api.business.updateUiPreference(businessId, key, value);
            },
            onMutate: (param)=>{
                let { key, value } = param;
                writeUiPreferenceToCache(key, value);
            },
            retry: (failureCount, err)=>failureCount < 3 && isTransientError(err),
            retryDelay: ()=>1000
        });
        return {
            updateUiPreference: mutate,
            isLoading,
            error
        };
    };
export const useUpdateVendorUiPreference = makeUpdateUiPreferenceHook();
export const useUpdateCustomerUiPreference = makeUpdateUiPreferenceHook();
export const useUpdateCommonUiPreference = makeUpdateUiPreferenceHook();
